const getCssVarValueByNameWithMemo = () => {
  const rootStyles = getComputedStyle(document.documentElement);

  return (varName: string): string => rootStyles.getPropertyValue(varName).trim();
};

export const getCssVarValueByName = getCssVarValueByNameWithMemo();
